<button
  type="button"
  hlmBtn
  variant="outline"
  size="lg"
  class="h-10 w-full gap-3"
  (click)="triggerGoogle()"
  [attr.aria-label]="'AUTH.CONTINUE_WITH_GOOGLE' | translate"
>
  <span class="flex size-5 shrink-0 items-center justify-center" aria-hidden="true">
    <svg class="block size-5" width="20" height="20" viewBox="0 0 256 262" xmlns="http://www.w3.org/2000/svg">
      <path fill="#4285F4" d="M255.82 133.5c0-10.6-.93-18.3-2.94-26.3H130.5v47.6h71.9c-1.45 11.9-9.3 29.8-26.8 41.9l-.25 1.7 39 30.2 2.7.3c24.7-22.8 38.7-56.3 38.7-95z"/>
      <path fill="#34A853" d="M130.5 261.1c35.2 0 64.8-11.6 86.4-31.7l-41.2-31.9c-11 7.7-25.7 13.1-45.2 13.1-34.6 0-64-22.8-74.5-54.5l-1.54.1-40.3 31.2-.53 1.5C35.7 232.3 79.9 261.1 130.5 261.1z"/>
      <path fill="#FBBC05" d="M56 156.1c-2.8-8.1-4.5-16.8-4.5-25.6 0-8.9 1.7-17.5 4.4-25.6l-.08-1.7L15.1 71.3l-1.3.6C5 90.6 0 111.2 0 132.9s5 42.3 13.8 61l42.2-32.8z"/>
      <path fill="#EA4335" d="M130.5 50.7c24.5 0 41 10.6 50.5 19.5l36.9-36C195.2 12.1 165.7 0 130.5 0 79.9 0 35.7 28.8 13.8 71.9L56 104.9c10.5-31.7 39.9-54.2 74.5-54.2z"/>
    </svg>
  </span>
  <span>{{ 'AUTH.CONTINUE_WITH_GOOGLE' | translate }}</span>
</button>

<div
  #googleContainer
  class="pointer-events-none invisible absolute -left-[9999px] size-px overflow-hidden"
  aria-hidden="true"
></div>
